export function useTradeCoin() {
  return {
    address: '0xFCBD14DC51f0A4d49d5E53C2E0950e0bC26d0Dce',
    aiAgentName: 'berAIs',
    decimals: 18,
    hsIcon: '/src/images/vault/hs_honey.png',
    hsTokenSymbol: 'hsHONEY',
    icon: '/src/images/icon/honey.png',
    iconAigent: '/src/images/vault/berais.svg',
    logoDex: '/src/images/logo/logo_holdstation_dex_bera.png',
    networkName: 'Berachain',
    seoName: 'Holdstation BeFutures',
    symbol: 'WLD',
  };
}
